module.exports = __webpack_public_path__ + "img/wallet.8cabc6b4.svg";